import { Component } from '@angular/core';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { BaseForm } from '@app/modules/forms/base.form';
import { Moment } from 'moment';

@Component({
    selector: 'app-change-policy',
    templateUrl: 'change-policy.template.html',
    styleUrls: ['change-policy.style.scss'],
})
export class ChangePolicyForm extends BaseForm {
    timeOffPolicies: TimeOffPolicy[] = [];
    selectedDate: Moment;
    selectedTimeOffPolicyId: number;
    currentlyAssignedTimeOffPolicyId: number;
    timeOffPoliciesForTimeOffType: TimeOffPolicy[] = [];

    async getTimeOffPolicies(timeOffTypeId: number, assignedTimeOffPolicies: TimeOffPolicy[]): Promise<void> {
        const [timeOffPoliciesForTimeOffType] = await TimeOffPolicy.where('timeOffTypeId', timeOffTypeId).all();

        this.currentlyAssignedTimeOffPolicyId = assignedTimeOffPolicies.find(
            (timeOffPolicy) => timeOffTypeId === timeOffPolicy.timeOffTypeId
        ).id;
        this.timeOffPoliciesForTimeOffType = timeOffPoliciesForTimeOffType;
        this.selectedTimeOffPolicyId = this.currentlyAssignedTimeOffPolicyId;
    }
}
